<template>
  <div class="landing" id="home">
    <nav>
      <div class="logo_and_text">
        <div class="logo">
          <img src="@/assets/images/image 4.png" alt="" />
        </div>
      </div>
      <div class="links">
        <ul>
          <li>
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#features">Features</a>
          </li>
          <li>
            <a href="#faq">FAQ</a>
          </li>
          <li>
            <a href="/dashboard" class="dashboardbtn">Dashboard</a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="mobnav">
      <div class="logo">
        <img src="@/assets/images/image 4.png" alt="" class="moblogo" />
      </div>
      <div class="burger-container">
        <div id="burger">
          <div class="bar topBar"></div>
          <div class="bar btmBar"></div>
        </div>
      </div>
      <ul class="menu">
        <li class="menu-item"><a href="#home">Home</a></li>
        <li class="menu-item"><a href="#features">Features</a></li>
        <li class="menu-item"><a href="#faq">FAQ</a></li>
        <li class="menu-item">
          <a href="/dashboard">Dashboard</a>
        </li>
      </ul>
    </div>

    <!-- lol -->
    <div class="first" id="home">
      <img src="@/assets/images/leftcloud.svg" class="leftcloud" />
      <img src="@/assets/images/rightcloud.svg" class="rightcloud" />
      <div class="headersection">
        <p class="headertext1">
          The ultimate exclusive sneaker & info source
        </p>

        <p class="headertext2">
          No more disappointment during release days. The Stashed Membership is
          the ultimate advantage for sneakerheads.
        </p>
        <p class="headertext3" v-if="!inStock">
          {{
            new Date(startDate).getTime() > Date.now()
              ? `Available ${new Date(startDate)
                  .toLocaleDateString()
                  .replace("/2021", "")} at ${
                  new Date(startDate).toLocaleTimeString().split(":")[0]
                }:${new Date(startDate).toLocaleTimeString().split(":")[1]} ${
                  new Date(startDate).toLocaleTimeString().split(" ")[1]
                    ? new Date(startDate).toLocaleTimeString().split(" ")[1]
                    : ""
                }`
              : "Sold out"
          }}
        </p>
        <div class="buttoncontainer">
          <button
            class="headerbtn1"
            v-bind:class="{ outofstock: !inStock }"
            id="purchaseBtn"
          >
            {{ inStock ? "Purchase" : "Coming soon" }}
          </button>
          <button class="headerbtn2">Learn more</button>
        </div>
      </div>
      <img src="" class="shoepositioned" id="shoeimg" />
      <img src="@/assets/images/highlight.svg" class="highlight" />
    </div>

    <!-- SUBPARTS -->
    <div class="second" id="features">
      <div class="text">
        <h1 class="head">Backdoor for major releases</h1>
        <p class="subhead">
          Annoyed by the SNKRS app, bots skipping the queue and raffles you
          never win?

          <br /><br />

          With a backdoor at the biggest EU stores, members get a second chance
          of getting the most limited sneakers for way below ridiculous resell
          prices. We provide backdoor for GR's like Jordan's and Yeezy's but
          also limited launches like Off White and Travis Scott x Nike.
        </p>
      </div>
      <div class="image">
        <img src="@/assets/images/backdoor.png" id="img1" alt="" />
      </div>
    </div>

    <div class="third">
      <div class="image">
        <img src="@/assets/images/Group 8.png" id="img2" alt="" />
      </div>
      <div class="text">
        <h1 class="head">Sneaker Holding</h1>
        <p class="subhead">
          If you've ever sold a limited sneaker shortly after the release,
          you've probably experienced regret after seeing prices skyrocket
          days/weeks after you sold them. Being the creators of market mark-up,
          we tell you which sneakers we expect to go up or down in price, or
          easier said, which to cop and which to drop.
        </p>
      </div>
    </div>

    <div class="fourth">
      <div class="text">
        <h1 class="head">Reward System, earn exclusive rewards</h1>
        <p class="subhead">
          Stay active, level up and earn exclusive rewards such as retail priced
          backdoors, guaranteed backdoors and 50+ other rewards!
        </p>
      </div>
      <div class="image">
        <img src="@/assets/images/Group 14.png" id="img3" alt="" />
      </div>
    </div>

    <div class="fifth">
      <div class="image">
        <img src="@/assets/images/Group 16.png" id="img4" alt="" />
      </div>
      <div class="text">
        <h1 class="head">Exclusive Info, stay in the loop</h1>
        <p class="subhead">
          With insiders at Nike SNKRS and the biggest stores, you'll be one of
          first to know about exclusive info such as restocks, shock drops,
          stock info and so much more.
        </p>
      </div>
    </div>

    <!--<div class="sixth">
        <div class="text">
          <h1 class="head">Reward System, earn exclusive rewards</h1>
          <p class="subhead">
            Stay active, level up and earn exclusive rewards such as retail priced backdoors, guaranteed backdoors and 50+ other rewards!
          </p>
        </div>
        <div class="image">
          <img src="@/assets/images/star 1.png" id="img5" alt="" />
        </div>
      </div>-->

    <div class="FAQ_with_kutta" id="faq">
      <div class="clearfix1">
        <h2 class="feature_subheading">Frequently asked questions</h2>
      </div>
      <div class="accordian">
        <div class="accordian-item">
          <div class="accordian-item-header">
            <h4>Who's the Stashed membership for?</h4>
          </div>
          <div class="accordian-item-body">
            <div class="accordian-item-body-content">
              <p>
                Stashed is for everyone. Unlike others, we've created something
                for everyone. Whether you're a sneaker connoisseur or hardcore
                reseller. Whether you're just looking to stay updated and buy a
                personal or want to get as many pairs as possible. Stashed is
                for you.
              </p>
            </div>
          </div>
        </div>
        <div class="accordian-item">
          <div class="accordian-item-header">
            <h4>Which region is the Stashed membership for?</h4>
          </div>
          <div class="accordian-item-body">
            <div class="accordian-item-body-content">
              <p>
                We're currently heavily EU focussed and aim to expand to the US
                later this year.
              </p>
            </div>
          </div>
        </div>
        <div class="accordian-item">
          <div class="accordian-item-header">
            <h4>Which payment methods do you accept?</h4>
          </div>
          <div class="accordian-item-body">
            <div class="accordian-item-body-content">
              <p>
                We currently only accept credit card payments. We're looking to
                add other payment methods later this year.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="signup_container" id="contact">
        <div class="signup_wrapper">
          <div class="signup_header">
            <h1>Sign up to receive updates</h1>
          </div>
          <div class="signup">
            <input
              type="text"
              placeholder="Your email"
              class="email_conatiner"
            />
            <button class="signupbtn_container">Sign Up</button>
            <button class="contactbtn_container">Contact Us</button>
          </div>
        </div>
      </div>-->
    <div id="mc_embed_signup">
      <form
        action="https://stashedsnkrs.us4.list-manage.com/subscribe/post?u=a88a599fb4d28c494053233b3&amp;id=9f8f699cce"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
        novalidate
      >
        <div id="mc_embed_signup_scroll">
          <h2 class="singup">
            Sign up and get access to our free discord server to receive
            exclusive and early insights.
          </h2>
          <div class="indicates-required">
            <span class="asterisk">*</span> indicates required
          </div>
          <div class="mc-field-group">
            <label for="mce-FNAME">First Name </label>
            <input type="text" value="" name="FNAME" class="" id="mce-FNAME" />
          </div>
          <div class="mc-field-group">
            <label for="mce-EMAIL"
              >Email Address <span class="asterisk">*</span>
            </label>
            <input
              type="email"
              value=""
              name="EMAIL"
              class="required email"
              id="mce-EMAIL"
            />
          </div>
          <div hidden="true">
            <input type="hidden" name="tags" value="65461" />
          </div>
          <div id="mce-responses" class="clear">
            <div
              class="response"
              id="mce-error-response"
              style="display:none"
            ></div>
            <div
              class="response"
              id="mce-success-response"
              style="display:none"
            ></div>
          </div>
          <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true">
            <input
              type="text"
              name="b_a88a599fb4d28c494053233b3_9f8f699cce"
              tabindex="-1"
              value=""
            />
          </div>
          <div class="clear">
            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              class="button"
            />
          </div>
        </div>
      </form>
    </div>
    <div class="footer">
      <div class="footer-inner footer-icon">
        <img src="@/assets/images/image 4.png" alt="" />
      </div>
      <div class="footer-inner">
        <ul class="footer-ul">
          <li><a href="#" id="bold_link1">Navigation</a></li>
          <li><a href="#home">Home</a></li>
          <li><a href="#features">Features</a></li>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </div>
      <div class="footer-inner">
        <ul class="footer-ul">
          <li><a href="#" id="bold_link2">Legals</a></li>
          <li>
            <a href="/terms-and-conditions">Terms & Conditions</a>
          </li>
        </ul>
      </div>
      <div class="footer-inner">
        <ul class="footer-ul">
          <li><a href="#" id="bold_link3">Socials</a></li>
          <li>
            <a href="https://twitter.com/stashedsnkrs" target="_blank"
              >Twitter</a
            >
          </li>
          <li>
            <a href="https://instagram.com/stashed_snkrs" target="_blank"
              >Instagram</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div id="licenseModal" class="modal hidden">
      <div class="modal-content">
        <div class="modal-body">
          <li id="close-modal"><span class="arrow arrow-left"></span></li>

          <div class="pause-modal1">
            <div class="firstone">Stashed Membership</div>
            <div class="secondone">€29,95 /month, Cancel anytime.</div>
            <div
              v-if="success"
              style="background: #19b719;width: 300px;border-radius: 4px; padding: 25.5px;margin-top: 20px;"
            >
              You successfully purchased the Stashed membership. You will
              receive an e-mail with your license key shortly. Don't forget to
              check your spam folder.
            </div>
            <div
              v-if="error"
              style="background: #c31818;width: 300px;border-radius: 4px; padding: 25.5px;margin-top: 20px;"
            >
              {{ errorMessage }}
            </div>
            <div v-if="!success && !error">
              <div class="fullnamelabel">Fullname</div>
              <input
                type="text"
                placeholder="Fullname"
                class="fullname"
                v-model="fullname"
              />
              <div class="email">Email address</div>
              <input
                type="email"
                placeholder="Email address"
                class="emailid"
                v-model="emailAddress"
              />
              <div class="street">Address line</div>
              <input
                type="text"
                placeholder="Address line"
                class="streetname"
                v-model="address1"
              />
              <div class="inline-form">
                <div class="column-form">
                  <div class="citylabel">City</div>
                  <input
                    type="text"
                    placeholder="City"
                    class="city"
                    v-model="city"
                  />
                </div>
                <div class="column-form">
                  <div class="postal">Postal Code</div>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    class="postalcode"
                    v-model="zip"
                  />
                </div>
              </div>
              <div class="countryname">Country</div>
              <select v-model="country" class="country">
                <option disabled selected value="">Select country</option>
                <option value="AF">Afghanistan</option>
                <option value="AX">Aland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD"
                  >Congo, Democratic Republic of the Congo</option
                >
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Cote D'Ivoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curacao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and Mcdonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP"
                  >Korea, Democratic People's Republic of</option
                >
                <option value="KR">Korea, Republic of</option>
                <option value="XK">Kosovo</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libyan Arab Jamahiriya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK"
                  >Macedonia, the Former Yugoslav Republic of</option
                >
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="AN">Netherlands Antilles</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Reunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthelemy</option>
                <option value="SH">Saint Helena</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="CS">Serbia and Montenegro</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS"
                  >South Georgia and the South Sandwich Islands</option
                >
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan, Province of China</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="US">United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.s.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
              <div class="carddetails">Card Details</div>
              <div class="cardInfo">
                <div style="width:100%;" ref="card"></div>
              </div>
              <div class="inline">
                <label class="container con-two">
                  <input type="checkbox" checked="checked" />
                  <span class="checkmark"></span>
                </label>
                <p class="agree">
                  By purchasing, you agree to the Stashed
                  <a href="/terms-and-conditions" class="blue-text"
                    >Terms of Service</a
                  >.
                </p>
              </div>

              <button class="paynow" v-on:click="purchase">
                {{ submitting === true ? "Processing..." : "€29.95 /month" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import $ from "jquery";
import * as VueAos from "vue-aos";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
Vue.use(VueAos);
import { gsap, ScrollTrigger, Power2 } from "gsap/all";
import { loadStripe } from "@stripe/stripe-js";

export default {
  name: "Purchase",
  data() {
    return {
      dataFetched: false,
      inStock: false,
      type: "",
      startDate: "",
      endDate: "",
      stripe: null,
      card: null,
      fullname: "",
      emailAddress: "",
      address1: "",
      city: "",
      zip: "",
      country: "",
      submitting: false,
      error: false,
      errorMessage: "",
      success: false,
    };
  },
  methods: {
    fetchData() {
      fetch(`/api/v1/release/getData`, {
        credentials: "include",
      })
        .then((res) => res.json())
        .then(async (res) => {
          this.stripe = await loadStripe(res.publicKey);
          this.dataFetched = true;
          this.inStock = res.inStock;
          this.type = res.type;
          this.startDate = res.startDate;

          if (new Date(this.startDate).getTime() > new Date().getTime()) {
            this.inStock = false;
          }

          this.endDate = res.endDate;
          this.loadCardElements();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadCardElements() {
      let elements = this.stripe.elements();

      let style = {
        base: {
          iconColor: "#2A2A2A",
          color: "#fff",
          fontWeight: 300,
          fontFamily: "Lato, Open Sans, Segoe UI, sans-serif",
          fontSize: "13px",
          background: "red",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justfiyContent: "center",
          "::placeholder": {
            color: "rgba(255,255,255,.5)",
            fontSize: "13px",
          },
        },
      };

      this.card = elements.create("card", { hidePostalCode: true, style });

      const loadCard = setInterval(() => {
        if (this.$refs.card) {
          clearInterval(loadCard);
          this.card.mount(this.$refs.card);
        }
      }, 10);

      this.card.on("change", (error) => {
        this.displayError(error);
      });
    },
    displayError({ error }) {
      if (error) {
        this.error = true;
        this.errorMessage = error.message;
      } else {
        this.error = false;
        this.errorMessage = "";
      }
    },
    async purchase(e) {
      e.preventDefault();

      if (this.submitting) return;

      this.error = false;
      this.errorMessage = "";
      this.success = false;

      const { fullname, emailAddress, address1, city, zip, country } = this;

      if (!fullname || fullname.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      if (!emailAddress || emailAddress.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      if (!address1 || address1.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      if (!city || city.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      if (!zip || zip.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      if (!country || country.trim() == "") {
        this.error = true;
        this.errorMessage = "All fields are required!";
      }

      this.submitting = true;

      let cardToken = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.card,
        billing_details: {
          name: fullname,
          email: emailAddress,
          address: {
            line1: address1,
            city: city,
            postal_code: zip,
            country: country,
          },
        },
      });

      if (cardToken.error) {
        this.error = true;
        this.errorMessage = cardToken.error.message;
        this.submitting = false;
        return;
      }

      if (!this.error) {
        fetch(`/api/v1/release/purchase`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullname,
            emailAddress,
            address1,
            city,
            zip,
            country,
            cardToken: cardToken.paymentMethod.id,
          }),
          credentials: "include",
        })
          .then(async (response) => {
            if (response.status == 402) {
              let data = await response.json();
              throw data;
            }
            return response.json();
          })
          // If the card is declined, display an error to the user.
          .then((result) => {
            if (result.error || result.message) {
              // The card had an error when trying to attach it to a customer.
              throw result.error ? result.error.message : result.error;
            }

            return result;
          })
          // Normalize the result to contain the object returned by Stripe.
          // Add the additional details we need.
          .then((result) => {
            return {
              paymentMethodId: cardToken.paymentMethod.id,
              subscription: result,
            };
          })
          // Some payment methods require a customer to be on session
          // to complete the payment process. Check the status of the
          // payment intent to handle these actions.
          .then(this.handlePaymentThatRequiresCustomerAction)
          // If attaching this card to a Customer object succeeds,
          // but attempts to charge the customer fail, you
          // get a requires_payment_method error.
          .then(this.handleRequiresPaymentMethod)
          // No more actions required. Provision your service for the user.
          .then(this.onSubscriptionComplete)
          .catch((error) => {
            this.submitting = false;
            // An error has happened. Display the failure to the user here.
            // We utilize the HTML element we created.
            console.log(error);
            this.errorMessage = error.message
              ? error.message
              : error.error
              ? error.error.message
              : error
              ? error
              : "";
            this.error = true;
          });
      }
    },
    handlePaymentThatRequiresCustomerAction({
      subscription,
      invoice,
      paymentMethodId,
      isRetry,
    }) {
      if (subscription && subscription.status === "active") {
        // Subscription is active, no customer actions required.
        return { subscription, paymentMethodId };
      }

      if (subscription && subscription.code && subscription.message) {
        throw subscription.message;
      }

      // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
      // If it's a retry, the payment intent will be on the invoice itself.
      let paymentIntent = invoice
        ? invoice.payment_intent
        : subscription.latest_invoice.payment_intent;

      if (
        paymentIntent.status === "requires_action" ||
        (isRetry === true && paymentIntent.status === "requires_payment_method")
      ) {
        return this.stripe
          .confirmCardPayment(paymentIntent.client_secret, {
            payment_method: paymentMethodId,
          })
          .then((result) => {
            if (result.error) {
              // Start code flow to handle updating the payment details.
              // Display error message in your UI.
              // The card was declined (i.e. insufficient funds, card has expired, etc).

              throw result.error.message;
            } else {
              if (result.paymentIntent.status === "succeeded") {
                // Show a success message to your customer.
                subscription.status = "active";
                return {
                  subscription: subscription,
                  invoice: invoice,
                  paymentMethodId: paymentMethodId,
                };
              }
            }
          })
          .catch((error) => {
            this.error = true;
            this.errorMessage = error;
          });
      } else {
        // No customer action needed.
        return { subscription, paymentMethodId };
      }
    },
    handleRequiresPaymentMethod({ subscription, paymentMethodId }) {
      if (subscription.status === "active") {
        // subscription is active, no customer actions required.
        return { subscription, paymentMethodId };
      } else if (
        subscription.latest_invoice.payment_intent.status ===
        "requires_payment_method"
      ) {
        throw "Your card was declined.";
      } else {
        return { subscription, paymentMethodId };
      }
    },
    onSubscriptionComplete(result) {
      this.submitting = false;
      // Payment was successful.
      if (result.subscription.status === "active") {
        // Change your UI to show a success message to your customer.
        // Call your backend to grant access to your service based on
        // `result.subscription.items.data[0].price.product` the customer subscribed to.
        this.error = false;
        this.errorMessage = "";
        this.success = true;
      }
    },
  },
  mounted() {
    let close = document.querySelector(".arrow-left");
    close.addEventListener("click", () => {
      let modalContent = document.querySelector(".modal-content");
      modalContent.style.transform = "translateY(100%)";
      setTimeout(() => {
        document.querySelector("#licenseModal").click();
      }, 250);
    });

    this.fetchData();
    var burger = document.querySelector(".burger-container"),
      header = document.querySelector(".mobnav");

    burger.onclick = function() {
      header.classList.toggle("menu-opened");
      document.querySelector(".menu").classList.toggle("visible");
    };

    document.querySelector(".menu-item").onclick = function() {
      header.classList.toggle("menu-opened");
      document.querySelector(".menu").classList.toggle("visible");
    };

    const prevIcon = '<img src="/images/left_arrow.png" alt:"left">';
    const nextIcon = '<img src="/images/right_arrow.png" alt:"right">';

    $(".owl-carousel").owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      navText: [prevIcon, nextIcon],
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        768: {
          items: 2,
        },
      },
    });

    const accordianItemHeaders = document.querySelectorAll(
      ".accordian-item-header"
    );

    accordianItemHeaders.forEach((accordianItemHeader) => {
      accordianItemHeader.addEventListener("click", () => {
        const current = document.querySelector(".accordian-item-header.active");

        if (current && current !== accordianItemHeader) {
          current.classList.toggle("active");
          current.nextElementSibling.style.maxHeight = 0;
        }
        accordianItemHeader.classList.toggle("active");

        const accordianItemBody = accordianItemHeader.nextElementSibling;

        if (accordianItemHeader.classList.contains("active")) {
          accordianItemBody.style.maxHeight =
            accordianItemBody.scrollHeight + "px";
        } else {
          accordianItemBody.style.maxHeight = 0;
        }
      });
    });

    gsap.registerPlugin(ScrollTrigger);
    const nav = document.querySelector("nav");

    gsap.fromTo(
      ".third",
      1,
      {
        opacity: 0,
        transform: "translateX(-100vw)",
      },
      {
        opacity: 1,
        transform: "translateX(0px)",
        clearProps: "transform",
        ease: Power2.easeInOut,
      }
    );
    gsap.fromTo(
      ".secondarytext",
      1,
      {
        opacity: 0,
        transform: "translateX(-100vw)",
      },
      {
        opacity: 1,
        transform: "translateX(0px)",
        clearProps: "transform",
        ease: Power2.easeInOut,
      }
    );

    gsap.fromTo(
      ".mobnav",
      1,
      {
        transform: "translateY(-20vw)",
      },
      {
        transform: "translateY(0px)",
        clearProps: "transform",
        ease: Power2.easeInOut,
      }
    );
    gsap.fromTo(
      nav,
      1,
      {
        transform: "translateY(-10vw)",
      },
      {
        transform: "translateY(0px)",
        clearProps: "transform",
        ease: Power2.easeInOut,
      }
    );

    gsap.fromTo(
      ".FAQ_with_kutta",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".sixth",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );

    gsap.fromTo(
      ".testimonial_wrapper",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".fifth",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );

    gsap.fromTo(
      ".second",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".nav",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );
    gsap.fromTo(
      ".third",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".first",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );
    gsap.fromTo(
      ".fourth",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".second",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );

    gsap.fromTo(
      ".fifth",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".third",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );

    gsap.fromTo(
      ".sixth",
      1,
      {
        transform: "translateY(10vw)",
        opacity: 0,
      },
      {
        transform: "translateY(0vw)",
        opacity: 1,
        ease: Power2.easeInOut,
        clearProps: "transform",
        scrollTrigger: {
          trigger: ".fourth",
          start: "bottom 100px",
          toggleActions: "play none none none",
        },
      }
    );

    var theImages = new Array();
    theImages[0] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/MELODY.png?v=1622820115";
    theImages[1] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DH8565_100_E_PREM.png?v=1622820115";
    theImages[2] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DH3228_100_E_PREM.png?v=1622820115";
    theImages[3] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DH0690_200_E_PREM.png?v=1622820115";
    theImages[4] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DD1876_700_E_PREM.png?v=1622820115";
    theImages[5] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DD1870_100_E_PREM.png?v=1622820115";
    theImages[6] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DC9936_100_E_PREM.png?v=1622820115";
    theImages[7] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-DA2728_100_E_PREM.png?v=1622820115";
    theImages[8] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CV9388_100_E_PREM.png?v=1622820115";
    theImages[9] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CU3244_100_E_PREM.png?v=1622820115";
    theImages[10] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CU1726_101_E_PREM.png?v=1622820115";
    theImages[11] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CT8480_001_E_PREM.png?v=1622820115";
    theImages[12] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CT5053_001_E_PREM.png?v=1622820115";
    theImages[13] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CT2552_800_E_PREM.png?v=1622820115";
    theImages[14] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CT0856_700_E_PREM.png?v=1622820115";
    theImages[15] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CT0856_100_E_PREM.png?v=1622820115";
    theImages[16] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CK5666_100_E_PREM.png?v=1622820115";
    theImages[17] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CQ7629_100_E_PREM.png?v=1622820115";
    theImages[18] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CI1184_146_E_PREM.png?v=1622820115";
    theImages[19] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CI1173_400_E_PREM.png?v=1622820115";
    theImages[20] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CD7001_300_E_PREM.png?v=1622820115";
    theImages[21] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CD6578_507_E_PREM.png?v=1622820115";
    theImages[22] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CD4487_100_E_PREM.png?v=1622820115";
    theImages[23] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-CD0461_401_E_PREM.png?v=1622820115";
    theImages[24] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-BV0073_301_E_PREM.png?v=1622820115";
    theImages[25] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-BV0073_300_E_PREM.png?v=1622820115";
    theImages[26] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AQ0818_148_E_PREM.png?v=1622820115";
    theImages[27] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AQ0818_100_E_PREM.png?v=1622820114";
    theImages[28] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AJ4219_400_E_PREM.png?v=1622820115";
    theImages[29] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AA3834_101_E_PREM.png?v=1622820115";
    theImages[30] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AA3830_100_E_PREM.png?v=1622820115";
    theImages[31] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-AA3830_002_E_PREM.png?v=1622820115";
    theImages[32] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-555088_402_E_PREM.png?v=1622820115";
    theImages[33] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-555088_140_E_PREM.png?v=1622820115";
    theImages[34] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-555088_105_E_PREM.png?v=1622820115";
    theImages[35] =
      "https://cdn.shopify.com/s/files/1/0016/3246/9027/files/JORDAN-555088_028_E_PREM.png?v=1622820115";

    var p = theImages.length;

    var whichImage = Math.round(Math.random() * (p - 1));

    function showImage() {
      let image = new Image();
      image.src = theImages[whichImage];
      document.getElementById("shoeimg").src = theImages[whichImage];
    }

    showImage();

    var licenseModal = document.getElementById("licenseModal");

    var btn = document.getElementById("purchaseBtn");

    let _this = this;

    btn.onclick = function() {
      if (!_this.inStock) return;
      if (new Date(_this.startDate).getTime() > new Date().getTime()) return;

      _this.error = false;
      _this.errorMessage = "";
      _this.success = false;

      licenseModal.classList.remove("hidden");
      setTimeout(() => {
        let modalContent = document.querySelector(".modal-content");
        modalContent.style.transform = "translateY(54%)";
      }, 500);
    };

    window.onclick = function(event) {
      if (event.target == licenseModal) {
        licenseModal.classList.add("hidden");
      }
    };
  },
};
</script>

<style>
@import "../../assets/css/landing.css";

.hidden {
  display: none !important;
}
#mc_embed_signup {
  background: transparent;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
  width: 600px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  color: white;
}
#mc-embedded-subscribe {
  background-color: #777 !important;
}
#mc_embed_signup .mc-field-group input {
  width: 94% !important;
  background-color: #23232a !important;
  color: white !important;
}
@media only screen and (max-width: 500px) {
  #mc_embed_signup .indicates-required {
    margin-right: 10% !important;
  }
  #mc_embed_signup .button {
    width: auto !important;
  }
  #mc_embed_signup {
    width: 100% !important;
  }
}
</style>
